import TitleAndImage from "../sections/TitleAndImage";
import WhoAmI from "../sections/WhoAmI";
import MyJourney from "../sections/MyJourney";
import Skills from "../sections/Skills";
import {
  MurquabExperience,
  FreelanceExperience,
  GenophoreExperience,
  EarlyFreelanceExperience,
  UniversityExperience,
} from "../sections/Experience";
import FreelanceAccounts from "../sections/FreelanceAccounts";
import DownloadCV from "../sections/DownloadCV";
import ContactMe from "../sections/ContactMe";
import {
  // MoreProjectsAndDetailsOnNotion,
  MyProjects1,
  MyProjects2,
  MyProjects3,
  MyProjects4,
  MyProjects5,
} from "../sections/MyProjects";
import { Grid } from "@mui/material";
import { navItemsIds } from "../components/NavBar";
import {
  FreestyleAdventures1,
  FreestyleAdventures2,
  FreestyleAdventures3,
} from "../sections/FreestyleAdventures";
// import DigitalStore from "../sections/DigitalStore";

function HomePageMobile() {
  return (
    <Grid container gap={5} direction={"column"} justifyContent={"center"}>
      <Grid>
        <TitleAndImage />
      </Grid>
      <Grid className={navItemsIds.whoAmI} sx={{ py: 10 }}>
        <WhoAmI />
      </Grid>
      <Grid>
        <MyJourney />
      </Grid>
      <Grid className={navItemsIds.skills} sx={{ py: 10 }}>
        <Skills />
      </Grid>
      <Grid className={navItemsIds.adventures}>
        <FreestyleAdventures1 />
      </Grid>
      <Grid>
        <FreestyleAdventures2 />
      </Grid>
      <Grid>
        <FreestyleAdventures3 />
      </Grid>
      <Grid sx={{ width: "100%", pt: 10 }} className={navItemsIds.experience}>
        <MurquabExperience />
      </Grid>
      <Grid sx={{ width: "100%" }}>
        <FreelanceExperience />
      </Grid>
      <Grid sx={{ width: "100%" }}>
        <GenophoreExperience />
      </Grid>
      <Grid sx={{ width: "100%" }}>
        <EarlyFreelanceExperience />
      </Grid>
      <Grid sx={{ width: "100%" }}>
        <UniversityExperience />
      </Grid>
      <Grid className={navItemsIds.projects} sx={{ pt: 10 }}>
        <MyProjects1 />
      </Grid>
      <Grid>
        <MyProjects2 />
      </Grid>
      <Grid>
        <MyProjects3 />
      </Grid>
      <Grid>
        <MyProjects4 />
      </Grid>
      <Grid>
        <MyProjects5 />
      </Grid>
      {/* <Grid>
        <MoreProjectsAndDetailsOnNotion />
      </Grid> */}
      {/* <Grid sx={{ py: 10 }}>
        <DigitalStore />
      </Grid> */}
      <Grid className={navItemsIds.freelancer} sx={{ py: 10 }}>
        <FreelanceAccounts />
      </Grid>
      <Grid className={navItemsIds.cv} sx={{ py: 10 }}>
        <DownloadCV />
      </Grid>
      <Grid
        className={navItemsIds.contactMe}
        sx={{ pt: 10 }}
        display={"flex"}
        direction={"column"}
        justifyContent={"space-between"}
      >
        <ContactMe />
      </Grid>
    </Grid>
  );
}

export default HomePageMobile;
